import React from 'react';
import { TrashIcon } from '../icons';
import { renderIcon } from '../../SprintDetail/FlowchartView/utils/renderIcon';

/**
 * Trash item for the trash search popup
 * Displays trashed campaign, template, or doc
 */
const TrashSearchItem = ({
  sprint,
  trashedItemInfo,
  isTemplate = false,
  isDoc = false,
  onRestoreSprint,
  onPermanentlyDeleteSprint,
}) => {
  const displayName = sprint.name || sprint.title || 'Untitled';

  const deletedDate = sprint.deletedAt
    ? new Date(sprint.deletedAt).toLocaleDateString()
    : '';

  let daysRemaining = null;
  if (sprint.expiresAt) {
    const now = Math.floor(Date.now() / 1000);
    const secondsRemaining = sprint.expiresAt - now;
    daysRemaining = Math.max(0, Math.ceil(secondsRemaining / (24 * 60 * 60)));
  }

  const handleRestore = (e) => {
    e.stopPropagation();
    onRestoreSprint?.(sprint.id);
  };

  const handlePermanentDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Permanently delete "${displayName}"? This cannot be undone.`)) {
      onPermanentlyDeleteSprint?.(sprint.id);
    }
  };

  return (
    <div
      className={`search-popup__item search-popup__item--trashed${
        isDoc ? ' search-popup__item--doc' : ''
      }${trashedItemInfo?.isOrphaned ? ' search-popup__item--orphaned' : ''}`}
    >
      <span className={`search-popup__item-icon ${isDoc ? '' : 'search-popup__item-icon--trash'}`}>
        {isDoc ? (
          renderIcon(sprint.icon, { size: '14px', fallback: <span>📄</span> })
        ) : (
          <TrashIcon size={14} />
        )}
      </span>
      <div className="search-popup__item-content">
        <span className="search-popup__item-name">
          {displayName}
          {isTemplate && <span className="search-popup__item-badge">Template</span>}
          {isDoc && <span className="search-popup__item-badge search-popup__item-badge--doc">Document</span>}
        </span>
        <span className="search-popup__item-meta">
          {isDoc
            ? `Document • ${deletedDate}`
            : trashedItemInfo?.isOrphaned
              ? `Parent "${trashedItemInfo.originalParentName || 'unknown'}" deleted • ${deletedDate}`
              : deletedDate}
          {daysRemaining !== null && (
            <span className="search-popup__item-expires">
              {daysRemaining === 0 ? ' • Expires today' : ` • ${daysRemaining}d left`}
            </span>
          )}
        </span>
      </div>
      <div className="search-popup__item-actions">
        <button
          className="search-popup__item-action search-popup__item-action--restore"
          onClick={handleRestore}
          title={
            isDoc
              ? 'Restore document (mission links and checkboxes come back too)'
              : trashedItemInfo?.isOrphaned
                ? 'Restore as top-level campaign'
                : `Restore ${isTemplate ? 'template' : 'campaign'}`
          }
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
        </button>
        <button
          className="search-popup__item-action search-popup__item-action--danger"
          onClick={handlePermanentDelete}
          title="Delete forever"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TrashSearchItem;
